/* eslint-disable camelcase */

class PaymentPlanForm {
  constructor($el) {
    if (!$el.length) return
    this.$root = $el

    this.$root.find('.js-is-recurring-select').change(this.handleRecurringChange.bind(this))
    this.$root.find('.js-plan-type-select').change(this.filterFieldsByPlanType.bind(this))

    this.filterFieldsByRecurrency()
    this.filterFieldsByPlanType()
  }

  filterFieldsByRecurrency() {
    const isRecurring = this.$root.find('.js-is-recurring-select').val() === 'true'

    const $recurringOptions = this.$root.find('.payment-plan-form__recurring-options')
    const $nonRecurringOptions = this.$root.find('.payment-plan-form__non-recurring-options')

    if (isRecurring) {
      $recurringOptions.show(0)
      $recurringOptions.find('input, select').removeAttr('disabled')
      $nonRecurringOptions.hide(0)
      $nonRecurringOptions.find('input, select').attr('disabled', 'true')
    } else {
      $recurringOptions.hide(0)
      $recurringOptions.find('input, select').attr('disabled', 'true')
      $nonRecurringOptions.show(0)
      $nonRecurringOptions.find('input, select').removeAttr('disabled')
    }
  }

  filterFieldsByPlanType() {
    const planTypeRegular = this.$root.find('.js-plan-type-select').val() === 'regular_plan'
    console.log('filterFieldsByPlanType', planTypeRegular)

    const extraOptions = this.$root.find('.payment-plan-form__coaching_plan-options')
    console.log('extraOptions', extraOptions)

    if (planTypeRegular) {
      extraOptions.hide(0)
      extraOptions.find('input, select, textarea').attr('disabled', 'true')
    } else {
      extraOptions.show(0)
      extraOptions.find('input, select, textarea').removeAttr('disabled')
    }
  }

  handleRecurringChange(event) {
    this.filterFieldsByRecurrency()
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new PaymentPlanForm($('.payment-plan-form'))
})
